import React from "react";
import { useSelector } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import { useGetProductByIdQuery, useGetSimilarProductsQuery } from "../features/products/productsApiSlice";
import Loading from "../components/Loading";
import ProductDetailBox from "../components/ProductDetailBox";
import ProductReviewList from "../components/ProductReviewList";
import { Product } from "../components/Product";

const ProductDetail = ({ useFor }) => {
  const pID = useParams();
  const location = useLocation();

  const { componentHeight } = useSelector((state) => state?.general);
  const { data: similarProduct, isSuccess: spSuccess } = useGetSimilarProductsQuery(pID.id);
  // const location = useLocation();
  // const {
  //   data: product,
  //   isLoading,
  //   isError,
  //   error,
  //   isSuccess,
  // } = useGetProductByIdQuery(pID.id);

  // Get initial product from navigation state or undefined
  const initialProduct = location.state?.product;
  //API calls
  const { data: fetchedProduct, isLoading, isError, error, isSuccess } = useGetProductByIdQuery(pID.id);

  const product = initialProduct || fetchedProduct;

  console.log("=====================");
  console.log(product);
  console.log(fetchedProduct);
  console.log("=====================");

  if (isLoading) return <Loading />;
  if (isError) return <div className="p-4 text-red-500">{error?.data?.message}</div>;

  const tableContent = similarProduct?.length
          ? similarProduct.map((product) => (
            console.log(product.productName),
              <Product key={product?._id} product={product} />
            ))
          : null;

  if (isSuccess) {
    return (
      <div 
        className="bg-custom-content-bg min-h-screen w-full"
        style={{ minHeight: `${componentHeight}vh` }}
      >
        <div className="max-w-6xl mx-auto px-4 py-6">
          {/* Changed from lg:flex-row to sm:flex-row for earlier breakpoint */}
          <div className="flex flex-col md:flex-row gap-4">
            {/* Adjusted widths for better proportion on smaller screens */}
            <div className="w-full md:w-[60%] lg:w-[70%] flex flex-col gap-4">
              <div className="">
                <ProductDetailBox product={product} page={useFor} />
              </div>
              <div className="w-full md:hidden">
                <ProductReviewList productId={product?._id} need={product?.need} />
              </div>
              <div className="w-full">
                <div className="w-[100%]">
                  <div className="grid grid-cols-1 xxs:grid-cols-2 sm:grid-cols-3 gap-2 w-full">{tableContent}</div>
                </div>
              </div>
            </div>
            {/* Reviews take up remaining space */}
            <div className="w-full md:w-[40%] lg:w-[30%] hidden md:block">
              <ProductReviewList productId={product?._id} need={product?.need} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default ProductDetail;